export default "__VITE_ASSET__B0VVC8s3__"